import React, { useEffect } from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import styles from "./local.module.css";
import logo from 'assets/images/sds-logo.png';

function ProductGrid() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/buy-button.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }} className={styles.gridBox}>
      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
      >
        {/* Business Growth Package */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QCMY0HSOCgSwMVnvc2h3PfL"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* Online Sales Package */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QCMaaHSOCgSwMVnVIvxIAxq"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* Digital Marketing */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBMTlHSOCgSwMVniGvBEF9z"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>
        
        {/* CANwebsite */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBLqQHSOCgSwMVnXnTf1vZA"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* SEO */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBMT0HSOCgSwMVn3Pno3DTN"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* CANstore */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBMUdHSOCgSwMVnLv5TFOmg"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* CANreports */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBMVcHSOCgSwMVnHA7AEy0W"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* CANmail */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBLvCHSOCgSwMVnbgJczUcw"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

        {/* CANassistant */}
        <Grid item xs={12} sm={6} md={4} className={styles.productItem}>
          <Paper className={styles.productContainer} elevation={3}>
            <stripe-buy-button
              buy-button-id="buy_btn_1QBMWWHSOCgSwMVniHH8zbxA"
              publishable-key="pk_test_51OVI8UHSOCgSwMVn7Gm6oOWRKXRTPAzDK4drQaGKl3rQBAL1dLKEuEnblDHuuDN2LnkDke88A6YnT2mAYPgBAomY00lp2Enakg"
            ></stripe-buy-button>
          </Paper>
        </Grid>

      </Grid>
    </Box>
  );
}

function Checkout() {
  return (
    <>
    <Box className={styles.headerBox}>
      <img src={logo} className={styles.logo} alt="Logo" />
    </Box>
    <Box className={styles.contentBox}>
      <Typography variant="h3" style={{marginBottom: "20px"}}>CANapps</Typography>
      <Typography variant="h5" style={{marginBottom: "40px"}}>
        Simplifying Complexity, Amplifying Productivity
      </Typography>
      <ProductGrid />
    </Box>
    <Box className={styles.footerBox}>
       <a href="https://streamdata.com/">Stream Data Systems</a> 
    </Box>
    </>
  );
}

export default Checkout;
